import { Box, CircularProgress, Stack } from '@mui/material'
import { styled } from '@mui/material/styles'
import { StopIcon } from '$common/icons/stop'
import { disableNoSleep } from '$func/no-sleep'
import { vibrate } from '$func/vibrate'
import { SEND_FIELD_DEFAULT_HEIGHT } from '$comp/_app/components/chat/components/conf'
import { t } from '$i18n'
import { useReactRecorder } from './recorder.react-hook'
import { Timer } from '../components/timer'
import { durationLabelRenderer } from '../components/durationLabelRenderer'
import { SendFieldIconButton } from '../../icon-button'

const StyledBox = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 34px;
  border-radius: 13px;
  width: 100%;
`

const AnimatedText = styled(Box)`
  /* @noflip */
  margin-left: auto;
  color: gray;
  &:after {
    overflow: hidden;
    display: inline-block;
    vertical-align: bottom;
    animation: ellipsis-keyframe steps(4, end) 900ms infinite;
    content: '\\2026'; /* ascii code for the ellipsis character */
    width: 0;
  }

  @keyframes ellipsis-keyframe {
    to {
      width: 1.25em;
    }
  }
`
const AnimatedRecordIcon = styled(Box)(({ theme }) => ({
  width: '10px',
  height: '10px',
  borderRadius: '15px',
  backgroundColor: theme.palette.error.main,
  animation:
    'blinker-keyframe 1s cubic-bezier(0.5, 0, 1, 1) infinite alternate',

  '@keyframes blinker-keyframe': {
    from: {
      opacity: 1,
    },
    to: {
      opacity: 0,
    },
  },
}))

const RecordIconRoot = styled(Box)`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 20px;
  height: 20px;
  /* @noflip */
  margin-right: 8px;
`

export function Recorder({ state, setRecorderState, setRecorderVoice }: any) {
  const isWaiting = state === 'WAITING'
  useReactRecorder({ state, setRecorderState, setRecorderVoice })

  if (state === 'STARTING') return null

  return (
    <Stack
      direction="row"
      justifyContent="space-between"
      alignItems="center"
      width="100%"
      padding="2px 8px"
      boxSizing="border-box"
      height={`${SEND_FIELD_DEFAULT_HEIGHT}px`}
      gap="8px"
      sx={{
        backgroundColor: 'white',
        borderTop: '1px solid #0000001A',
      }}
    >
      <SendFieldIconButton
        onClick={() => {
          if (isWaiting) return
          setRecorderState('WAITING')
          disableNoSleep('recorder')
          vibrate()
        }}
      >
        {isWaiting ? (
          <CircularProgress size={22} color="inherit" />
        ) : (
          <StopIcon />
        )}
      </SendFieldIconButton>
      <StyledBox>
        <AnimatedText>
          {isWaiting ? t('chat.processing') : t('chat.recording')}
        </AnimatedText>
        <Timer
          renderer={durationLabelRenderer}
          interval={100}
          stop={state === 'WAITING'}
        />
        <RecordIconRoot>
          <AnimatedRecordIcon />
        </RecordIconRoot>
      </StyledBox>
    </Stack>
  )
}
